<template>
  <section class="space-y-24 sm:px-0">
    <div
      v-for="(item, index) in passSectionItemPost"
      :key="index"
      class="grid grid-cols-1 md:grid-cols-2 gap-6 items-center"
    >
      <!-- Image -->
      <div
        class="w-full px-4"
        :class="{
          'md:order-first': index % 2 === 0,
          'md:order-last': index % 2 !== 0
        }"
      >
        <img
          :src="`https://archivegazette.iwcdeped.com/${item.media_link}`"
          :alt="item.title"
          class="w-full h-auto object-cover rounded-lg"
        />
      </div>

      <!-- Text -->
      <div class="p-4">
        <h1 class="text-3xl md:text-4xl font-bold text-primaryPalette">
          {{ item.title }}
        </h1>

        <div class="py-6 leading-8 break-words hyphens-auto text-left" lang="en">
          {{ converHtml(item.content) }}
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { convert } from 'html-to-text';

export default {
  props: {
    passSectionItemPost: {
      type: Array,
      required: true
    }
  },
  setup() {
    const converHtml = (val) => {
      return convert(val, {
        wordwrap: false,
        selectors: [
          { selector: 'p', options: { leadingLineBreaks: 0, trailingLineBreaks: 0 } },
          { selector: 'br', format: 'inline' }
        ],
        whitespaceCharacters: ' \t\r\n\f\u200b'
      })
        .replace(/\s+/g, ' ')
        .trim(); // 🔥 remove extra spaces
    };

    return { converHtml };
  }
};
</script>
